import { useTranslation } from 'react-i18next';

export const Loading = () => {
  const { t } = useTranslation('common');
  return <div>{t('loading')}</div>;
};
